import { CaseInfoBanner } from "src/components/case-info-banner/case-info-banner";
import { FormProvider } from "react-hook-form";
import { CaseFormTypes, FormSections, useCaseFormSetup } from "src/pages/case-landing/case-form-setup";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useCaseInAssessmentViewProps } from "src/pages/case-landing/views/case-in-assessment/case-in-assessment-view-model";
import LandingContactDetails from "src/pages/case-landing/sections/landing-contact-details-section";
import { mapCustomerUpdateFormData } from "src/utils/map-customer-update-data";
import { updateCustomerDetails } from "src/api/services/customer-service";
import { useCase } from "src/context/case-context";
import { useNavigate } from "react-router-dom";
import { Loader } from "src/utils/loader";
import { ContactPreference, PortalState } from "src/api/types/enums";

const CaseInAssessmentView = ({ state }: { state: PortalState }) => {
  const { t } = useTranslation();
  const [showError, setShowError] = useState<boolean>(false);
  const [showEditDetails, setShowEditDetails] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData] = useState<CaseFormTypes>({});
  const { customerData, setCustomerData } = useCase();
  const navigate = useNavigate();

  const { bannerKey } = useCaseInAssessmentViewProps(state);

  const formSections: FormSections[] = ["contactDetails", "agreeTsAndCs", "preferredContactChannel"];
  const methods = useCaseFormSetup({ formSections, t });
  const contactPreference = methods.watch("preferredContactChannel");
  const pageType = contactPreference === ContactPreference.Email ? "contactDetailsUpdatedEmail" : "contactDetailsUpdatedPost";

  if (!customerData) {
    return null;
  }

  const submitUpdate = async (formValues?: CaseFormTypes) => {
    try {
      const values = formValues ?? formData;
      const mappedData = mapCustomerUpdateFormData(values);

      setIsSubmitting(true);
      const updatedData = await updateCustomerDetails(mappedData);

      setCustomerData(updatedData);

      navigate("/thank-you", {
        state: { pageType: pageType },
      });
    } catch {
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <CaseInfoBanner translationKey={`caseInfoBanner.${bannerKey}`} />
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submitUpdate)} className="contents">
          <LandingContactDetails
            isVisible={true}
            showContactPreference={true}
            showError={showError}
            showExplanation={true}
            setShowError={setShowError}
            showEditDetails={showEditDetails}
            setShowEditDetails={setShowEditDetails}
            showSubmit={true}
          />
        </form>
      </FormProvider>
      {isSubmitting && <Loader />}
    </>
  );
};

export default CaseInAssessmentView;
